import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['buttonLeft', 'buttonRight', 'slider', 'sliderItem'];
  declare sliderTarget: HTMLDivElement;
  declare buttonLeftTarget: HTMLDivElement;
  declare buttonRightTarget: HTMLDivElement;
  declare sliderItemTargets: HTMLDivElement[];

  connect(): void {
    this.updateArrows();
  }

  updateArrows(): void {
    const { scrollLeft, clientWidth, scrollWidth } = this.sliderTarget;

    const isFullyLeft = scrollLeft === 0;
    const isFullyRight = scrollLeft + clientWidth >= scrollWidth;

    if (this.buttonLeftTarget.hasAttribute('disabled') !== isFullyLeft) {
      this.buttonLeftTarget.toggleAttribute('disabled', isFullyLeft);
    }

    if (this.buttonRightTarget.hasAttribute('disabled') !== isFullyRight) {
      this.buttonRightTarget.toggleAttribute('disabled', isFullyRight);
    }
  }

  get slideWidth(): number {
    const card = this.sliderItemTargets[5];
    if (!card) {
      return 0;
    }

    return this.sliderTarget.clientWidth - card.clientWidth;
  }

  handleLeftClick(): void {
    this.sliderTarget.scrollBy({ left: -this.slideWidth, behavior: 'smooth' });
  }

  handleRightClick(): void {
    this.sliderTarget.scrollBy({ left: this.slideWidth, behavior: 'smooth' });
  }
}
